import React from "react";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { TextField } from "Components/Base/Inputs/TextField";
import { Box } from "Components/Base/Layout/Box";
/**
 * @param {any} type - Typen av input elemtet.
 * @param {string} header - Titeln som visas ovanför komponenten.
 * @param {node} placeholder - Texten som visas i selectfielden innan användaren lägger in ett värde.
 * @param {node} label - Texten som visas i selectfielden och sedan ovanför den.
 * @param {any} defaultValue - Defaultvärdet.
 * @param {bool} required - En bool för att bestämma om ett inputvärde är nödvändigt.
 * @param {function} onChange - Funktion som anropas när värdet ändras.
 * @param {bool} error - Bool som avgör om labeln ska visas i error state.
 * @param {node} helperText - En hjälptext som visar vad användaren behöver göra.
 * @param {object} inputProps - Attribut som appliceras på input elementet.
 * @param {object} value - - Värdet av input elementet
 * @returns {JSX.Element} - Returnerar JSX-elementet för komponenten.
 */
const InputLabelHeader = ({
  type,
  header,
  placeholder,
  label,
  defaultValue,
  required,
  onChange,
  error,
  helperText,
  inputProps,
  value,
  fullWidth,
  InputProps,
  disabled,
  id,
}) => {
  // Pair the visual "required" indicator on the label with an explicit
  // aria-required on the input so assistive tech reliably announces it
  // regardless of MUI version (WCAG 2.1 AA).
  const accessibleInputProps = required
    ? { ...inputProps, "aria-required": "true" }
    : inputProps;

  return (
    <Box display="flex" flexDirection="column">
      {header && (
        <Box mb={1} width="fit-content">
          <InputLabel id={`${id}Label`} htmlFor={id} className={required ? "required" : ""}>
            {header}
          </InputLabel>
        </Box>
      )}
      <TextField
        id={id}
        {...{
          type,
          placeholder,
          label,
          defaultValue,
          required,
          onChange,
          error,
          helperText,
          inputProps: accessibleInputProps,
          value,
          fullWidth,
          InputProps,
          disabled,
        }}
      />
    </Box>
  );
};

export default InputLabelHeader;
